<mono-common-back-to-navigation-bar
  data-test="lmw-base-case-study-back-to-home-bar"
  [linkText]="mobileBackButtonText"
  linkTo="/"
  position="back-to-navigation__top"
></mono-common-back-to-navigation-bar>
<main id="content" #content class="site-container site-container--case-study">
  <section class="border-bottom-light" aria-describedby="ariaMainHeaderId">
    <div class="grid-container">
      <div class="grid-x grid-margin-x">
        <div class="cell tablet-portrait-7">
          <h1 id="ariaMainHeaderId">
            {{ caseStudyCms?.data?.attributes?.caseStudyFirstSection?.title }}
          </h1>
          <div class="show-for-tablet-portrait" [innerHTML]="caseStudyCms?.data?.attributes?.caseStudyFirstSection?.copy | dontSanitizeHtml"></div>
        </div>
        <div class="cell tablet-portrait-5">
          <mono-common-blockquote-image
          [imageSrc]="caseStudyCms?.data?.attributes?.caseStudyFirstSection?.image1x?.data?.attributes?.url"
          [image2xSrc]="caseStudyCms?.data?.attributes?.caseStudyFirstSection?.image2x?.data?.attributes?.url"
          [quote]="caseStudyCms?.data?.attributes?.caseStudyFirstSection?.imageQuote"
          [language]="language"
          [secondary]="true"
          >
          </mono-common-blockquote-image>
          <div class="hide-for-tablet-portrait" [innerHTML]="caseStudyCms?.data?.attributes?.caseStudyFirstSection?.copy | dontSanitizeHtml"></div>
        </div>
      </div>
      <div class="grid-x grid-margin-x">
        <div class="cell">
          <lmw-common-secondary-page-cta-panel data-test="lmw-common-case-study-secondary-cta-panel"
            [headingText]="caseStudyCms?.data?.attributes?.caseStudySecondSection?.title"
            [paragraphText1]="caseStudyCms?.data?.attributes?.caseStudySecondSection?.descriptionFirst"
            [firstLink]="browseAllSubjectsLink" 
            [firstLinkText]="caseStudyCms?.data?.attributes?.caseStudySecondSection?.browseSubjectsButton" 
          >
          </lmw-common-secondary-page-cta-panel>
        </div>
      </div>
    </div>
  </section>
</main>
